import { render, staticRenderFns } from "./PreviewMaterial.vue?vue&type=template&id=059c0d92&scoped=true&"
import script from "./PreviewMaterial.vue?vue&type=script&lang=js&"
export * from "./PreviewMaterial.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMaterial.vue?vue&type=style&index=0&id=059c0d92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c0d92",
  null
  
)

export default component.exports